<template>
  <section
    class="py-12 sm:py-16 md:py-20 lg:py-24 xl:py-32 bg-gradient-to-r from-[#0b105d] to-[#fe6d0d]"
  >
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 xl:px-12 text-center">
      <h2
        class="text-2xl sm:text-3xl md:text-4xl font-bold text-[#f4f4f4] mb-4 sm:mb-6"
        data-aos="fade-up"
      >
                {{ $t('cta.readyToTransform') }} 
      </h2>
      <p
        class="text-base sm:text-lg md:text-xl text-[#f4f4f4]/90 mb-8 sm:mb-10 max-w-xl sm:max-w-2xl mx-auto"
        data-aos="fade-up"
        data-aos-delay="100"
      >
        {{ $t('cta.joinRevolution') }}
      </p>
      <router-link
        to="/contact"
        class="group inline-flex items-center gap-2 sm:gap-3 px-8 sm:px-10 py-3 sm:py-4 bg-[#f4f4f4] text-[#0b105d] font-bold rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 text-base sm:text-lg"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <span>{{ $t('cta.getStartedToday') }}</span>
        <svg
          class="w-4 h-4 sm:w-5 sm:h-5 transform group-hover:translate-x-1 transition-transform"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M17 8l4 4m0 0l-4 4m4-4H3"
          ></path>
        </svg>
      </router-link>
    </div>
  </section>
</template>

<script setup lang="ts"></script>

<style scoped>
.shadow-3xl {
  box-shadow: 0 35px 60px -15px rgba(0, 0, 0, 0.3);
}
</style>
